export function getObjectKeys(items: any): string[] {
  return Object.keys(items);
}
